import { render, staticRenderFns } from "./ServiceAdd.vue?vue&type=template&id=45c93ca0&scoped=true&"
import script from "./ServiceAdd.vue?vue&type=script&lang=js&"
export * from "./ServiceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c93ca0",
  null
  
)

export default component.exports